var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[(!_vm.estimate)?_c('span',{staticClass:"resize-loading"},[_c('span',{staticClass:"loader"})]):_vm._e(),(_vm.estimate)?_c('estimate-form',{attrs:{"formErrors":_vm.formErrors,"estimateData":_vm.estimate,"loading":_vm.loading},on:{"formChanged":() => {
        _vm.alertLeave = true;
        _vm.get();
      },"onViewEstimate":_vm.onViewEstimate,"onCancelEstimate":_vm.onCancelEstimate,"onCloseEstimateModal":_vm.onCloseEstimateModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }